import React from 'react';

const InputField = ({type, name, value, onChange, placeholder, disabled}) => {
    return (
        <input type={type} name={name} value={value} onChange={onChange} placeholder={placeholder} disabled={disabled} />
    )
}

export default InputField